export default "__VITE_ASSET__BpF6rNRB__"